import React from 'react';

function Privacy(props) {

  return (
    <div className="page">
      <div className="text_block_white">
        <h3>Privacy Policy</h3>
        <p><strong>Last updated:</strong> July 3, 2026</p>

        <p>
          Last Mountain Wireless Inc. respects your privacy. This policy explains
          what information we collect, how we use it, and the choices you have
          when you contact us, request service, use our website, or communicate
          with us by phone, email, text message, or social media.
        </p>

        <h5>Information we collect</h5>
        <p>
          We may collect your name, service address, mailing address, phone
          number, email address, account details, service plan information,
          installation and support notes, payment and billing details, and any
          information you provide when you contact us.
        </p>
        <p>
          We may also collect technical information related to our website and
          service systems, such as browser information, device information,
          usage logs, message delivery information, and diagnostic information
          needed to provide and support Internet service.
        </p>

        <h5>Information collected through Facebook and other advertising</h5>
        <p>
          We may collect information through Facebook campaigns, lead forms, and
          other advertising campaigns. We use that information to prepare
          quotations, check service availability, answer questions, and arrange
          service.
        </p>

        <h5>How we use information</h5>
        <p>
          We use information to respond to inquiries, provide quotes, schedule
          installations, provide Internet service, process billing and payments,
          provide customer support, troubleshoot service issues, send account or
          service notifications, improve our services, and meet legal or
          regulatory obligations.
        </p>

        <h5>Text messaging and A2P 10DLC communications</h5>
        <p>
          If you provide your mobile phone number and consent to receive text
          messages from Last Mountain Wireless, we may use SMS or MMS messages
          for customer care, account notifications, appointment reminders,
          service updates, outage or troubleshooting messages, payment
          confirmations, and service-related offers where you have agreed to
          receive them.
        </p>
        <p>
          For text messaging, we may collect your mobile phone number, your
          consent status, message contents, message delivery data, timestamps,
          and related account or support information needed to send and manage
          those messages.
        </p>
        <p>
          <strong>
            Text messaging originator opt-in data and consent will not be shared
            with any third parties, excluding aggregators and providers of the
            Text Message services.
          </strong>
        </p>
        <p>
          <strong>
            No mobile information will be shared with third parties or
            affiliates for marketing or promotional purposes. Text messaging
            originator opt-in data and consent will not be shared with any
            third parties, excluding aggregators and providers of the text
            messaging services.
          </strong>
        </p>
        <p>
          You can opt out of text messages at any time by replying STOP. You
          can request help by replying HELP or by contacting us at
          <a className="black_link" href="tel://13069004321"> 1.306.900.4321</a>
          {' '}or <a className="black_link" href="mailto:info@lmw.email">info@lmw.email</a>.
        </p>

        <h5>How we share information</h5>
        <p>
          We do not sell your personal information. We may share information
          only as needed with service providers who help us operate our
          business, such as billing systems, payment processors, customer
          support tools, website hosting providers, SMS providers, messaging
          aggregators, and phone carriers. These providers are permitted to use
          information only to provide services to us.
        </p>
        <p>
          We may also disclose information if required by law, to protect our
          rights, to prevent fraud or abuse, or to respond to lawful requests.
        </p>

        <h5>Payment information</h5>
        <p>
          Payment card information may be handled by our payment processors. We
          do not use payment card information for marketing purposes.
        </p>

        <h5>Retention and security</h5>
        <p>
          We keep information only as long as reasonably needed for the purposes
          described in this policy, including customer service, accounting,
          legal, and operational needs. We use reasonable safeguards to protect
          information, but no system can be guaranteed to be perfectly secure.
        </p>

        <h5>Your choices</h5>
        <p>
          You may contact us to update your information, ask questions about
          your information, or request that we stop using your information for
          certain purposes. Some information may need to be kept for billing,
          service, security, or legal reasons.
        </p>

        <h5>Contact us</h5>
        <p>
          Last Mountain Wireless Inc.<br/>
          Box #8, Govan, SK S0G 1Z0<br/>
          Phone or text: <a className="black_link" href="tel://13069004321">1.306.900.4321</a><br/>
          Email: <a className="black_link" href="mailto:info@lmw.email">info@lmw.email</a>
        </p>
      </div>

    </div>);

}
  
export default Privacy;
